/* eslint-disable nonblock-statement-body-position */
/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from "react";
// ** Cutome Component
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Col,
  Row,
  Form,
  FormFeedback,
} from "reactstrap";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { Check } from "react-feather";
// import moment from "moment";
import Flatpickr from "react-flatpickr";
import { useForm, Controller } from "react-hook-form";
import "@styles/react/libs/flatpickr/flatpickr.scss";
import toast from "react-hot-toast";

import ReactDatePicker from "react-datepicker";
import {
  addEditorMaster,
  updateEditor,
} from "../../../../services/EditorsMaster/editorsMaster.services";
import { getErrorMsg } from "../../../../common/ErrorMessages/errorMessage";
import ToastContent from "../../../components/toast/toast";
import {
  getEditorMaster,
  getEditors,
} from "../../../../redux/editorsMaster/editorsMaster.thunk";
import { useDispatch } from "react-redux";

// import { getErrorMsg } from "../../../../common/ErrorMessages/errorMessage";

const AddNewEditor = ({
  editorModel,
  setEditorModel,
  isModelUseFor,
  //   setCurrentPage,
  //   EditeditorModel,
  //   setEditeditorModel,
}) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const defaultValues = {
    name: "",
  };

  const ValidationData = yup.object({
    name: yup.string().required("Name of Editor is Required"),
  });

  // ** Hooks

  const {
    // setValue,
    reset,
    // setError,
    control,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm({ defaultValues, resolver: yupResolver(ValidationData) });

  const getApiName = (payload) => {
    if (isModelUseFor === "ADD")
      return addEditorMaster({ editor_name: payload?.editor_name });
    else return updateEditor(payload);
  };

  const onSubmit = (data) => {
    setIsLoading(true);
    const payload = {
      id: editorModel?.data?.id,
      editor_name: data.name,
    };

    getApiName(payload)
      .then((res) => {
        toast((t) => (
          <ToastContent
            t={t.id}
            message={res?.message}
            icon={<Check size={12} />}
          />
        ));

        // setEditorModel({ isReApiCall: true, isOpen: false });
        setEditorModel({ ...editorModel, isOpen: false, data: null });
        dispatch(getEditors());

        if (isModelUseFor === "ADD") dispatch(getEditorMaster());
        reset();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("err: ", err);
        getErrorMsg(err);
        setIsLoading(false);
      });

    // if (Object.values(data).every((field) => field.length > 0)) {
    //   setIsLoading(true);
    // } else {
    //   for (const key in data) {
    //     if (data[key].length === 0) {
    //       setError(key, {
    //         type: "manual",
    //       });
    //     }
    //   }
    // }
  };

  useEffect(() => {
    if (editorModel?.data !== null) {
      reset({
        name: editorModel?.data?.editor_name,
      });
    } else if (editorModel?.data === null) {
      reset({
        name: "",
      });
    }

    return () => setIsLoading(false);
  }, [editorModel]);

  const ResetForm = () => {
    setEditorModel({ ...editorModel, isOpen: false });
    // setEditeditorModel("");
    reset();
  };

  return (
    <>
      <Modal
        isOpen={editorModel.isOpen}
        toggle={ResetForm}
        className="modal-dialog-centered modal-lg"
        // onClosed={() => setCardType("")}
      >
        <ModalHeader
          className="bg-transparent"
          toggle={() => {
            setEditorModel({ ...editorModel, isOpen: false });
            // setEditeditorModel("");
          }}
        ></ModalHeader>
        <ModalBody className="px-sm-5 mx-50 pb-5">
          <h1 className="text-center mb-1">
            {isModelUseFor === "EDIT" ? "Edit Editor" : "Add a New Editor"}
          </h1>

          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              {/* Project Name */}
              <Col xs="12">
                <div className="mb-1">
                  <Label className="form-label" for="name">
                    Name of Editor
                  </Label>
                  <Controller
                    id="name"
                    name="name"
                    control={control}
                    render={({ field }) => (
                      <Input
                        maxLength={20}
                        {...field}
                        type="text"
                        placeholder="Name of Editor"
                        // invalid={errors.name && true}
                      />
                    )}
                  />
                  {errors.name && (
                    <FormFeedback>{errors.name.message}</FormFeedback>
                  )}
                </div>
              </Col>

              <Col xs={12} className="mt-2 pt-50 text-center">
                <Button
                  type="submit"
                  className="me-1 "
                  color="primary"
                  disabled={isLoading || !isDirty}
                >
                  Submit
                </Button>

                <Button color="secondary" outline onClick={() => ResetForm()}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddNewEditor;
